import { put, all, call } from 'redux-saga/effects';

import { getDigitalURL } from '../../../../../services/UrlMapperService';
import { HttpService } from '../../../../../services/HttpService';
import { hideLoader } from '../../../../common/Helpers/loader';
import { isMoversFlow } from '../../../../common/Helpers';

import { nbsLabels } from '../../labels';

export function* getNBSPageData() {
  try {
    // console.log('API CALL TRIGGERED');
    const [apiResponse] = yield all([call(getNBSDataAPI)]);
    // console.log('***** nbs success *****');

    if (apiResponse?.data?.nbsVo) {
      yield put({
        type: 'NBS_RECEIVED',
        response: apiResponse.data.nbsVo,
        dbrFlag: apiResponse.data.dbrFlag,
      });
    } else {
      // const errorMsg = `${window.cq?.label?.DT_OD_CONFIRMATION_DUE_MONTHLY_NBS_ERROR_MESSAGE || window.checkoutCQ?.expressCheckout?.nbsErrorMsg}`;
      const errorMsg = nbsLabels.nbsErrorMsg;
      yield put({ type: 'NBS_ERROR', response: errorMsg });
      hideLoader();
    }
  } catch (err) {
    console.log(err);
  }
}

export const getNBSDataAPI = () => {
  const isLoggedIn = window.vzFlags?.isLoggedIn;
  const postData = {
    cartId: '',
    getCartDetails: true,
    nseFlow: isLoggedIn === 'true',
  };
  if (isLoggedIn && isMoversFlow()) {
    postData.intent = 'MOV_5G';
  }

  const apiURL = getDigitalURL('/orderprocessservice/nbsapi/nextbillsummary');
  return HttpService.post(apiURL, postData);
};
